import Popover from '@mui/material/Popover';
import React from 'react';

import FilterSelectorMenu from '../FilterMenus/FilterSelectorMenu';

const CustomPopover = ({
  column,
  headerAchorEl,
  closeFilterPopup,
  filters,
  setFilters,
  openCustomDateSelection,
  setOpenCustomDateSelection,
  allowDateRangeSelection,
}) => {
  const currentFilter = filters?.find((ele) => column?.columnDef?.id === ele?.id);

  const addFilter = (newFilter, shouldCloseFilterPopup = true) => {
    setFilters((prevState) => {
      return prevState.map((ele) => {
        if (ele.id === newFilter?.id) {
          return newFilter;
        } else {
          return ele;
        }
      });
    });
    if (shouldCloseFilterPopup) closeFilterPopup();
  };

  const virtualLoadWidth = openCustomDateSelection && currentFilter?.id === 'Date' ? 350 : 250;
  const virtualLoadHeight = openCustomDateSelection && currentFilter?.id === 'Date' ? 430 : 300;
  return (
    <Popover
      open={Boolean(headerAchorEl)}
      anchorEl={headerAchorEl}
      onClose={closeFilterPopup}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      <FilterSelectorMenu
        addFilter={addFilter}
        currentFilter={currentFilter}
        openCustomDateSelection={openCustomDateSelection}
        setOpenCustomDateSelection={setOpenCustomDateSelection}
        showMenuItemSelectBox={false}
        showSelectedDisabled={true}
        virtualLoadWidth={virtualLoadWidth}
        virtualLoadHeight={virtualLoadHeight}
        allowDateRangeSelection={allowDateRangeSelection}
      />
    </Popover>
  );
};

export default CustomPopover;
